module.exports = {"230231100":"拜泉镇","230231101":"三道镇","230231102":"兴农镇","230231103":"长春镇","230231104":"龙泉镇","230231105":"国富镇","230231106":"富强镇","230231200":"新生乡","230231201":"兴国乡","230231203":"上升乡","230231204":"兴华乡","230231206":"大众乡","230231209":"丰产乡","230231210":"永勤乡","230231212":"爱农乡","230231214":"时中乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230231.json
// module id = 647
// module chunks = 0